import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/departmentFeePay/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/v4ward/departmentFeePay/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/v4ward/departmentFeePay/remove', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/v4ward/departmentFeePay/submit', params, options);

export const generate = (params, options) =>
  request.post('/api/v4ward/departmentFeePay/generate', params, options);

export const getTreeChildrenNode = (parentId) => {
  return request({
    url: '/api/base/property/lazyBasePropertyTree',
    method: 'get',
    params: {
      parentId,
    },
  });
};
export const lazyDepartmentPropertyTree = (parentId) => {
  return request({
    url: '/api/base/property/lazyDepartmentPropertyTree',
    method: 'get',
    params: {
      parentId,
    },
  });
};


export const getDepartmentCommunityTree = (params) => {
  return request({
    url: '/api/base/property/getDepartmentCommunityTree',
    method: 'get',
    params
  });
};





export const update = (params, options) =>
  request.post('/api/v4ward/departmentFeePay/update', params, options);

export const updateFeeDetail = (params, options) =>
  request.post('/api/departmentFeePayDetail/v4ward/departmentFeePayDetail/update', params, options);

export const pay = (params, options) =>
  request.post('/api/v4ward/departmentFeePay/pay', params, options);
export const getDictionaryWithIntKey = (code, options) =>
  request.get(
    '/api/blade-system/dict/dictionaryWithIntKey?code=' + code,
    Object.assign({}, options, {})
  );

//开票接口
export const invoiceIssuePositive = (params, options) =>
  request.post('/api/v4ward/invoice/departmentIssuePositive',params, options);
